import React from "react";
import { Mail, Phone } from "lucide-react";

const Contact = () => (
  <div data-testid="contact-page">
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 lg:pt-20 pb-14">
      <div className="text-[10px] tracking-[0.4em] uppercase text-gold mb-6">Get In Touch</div>
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-ink max-w-3xl">
        Contact
      </h1>
      <p className="mt-6 text-base sm:text-lg text-ink-soft max-w-xl">
        For questions about the Traditional Wedding, please contact{" "}
        <span className="text-ink whitespace-nowrap">Etal Events</span>.
      </p>
    </section>

    <section className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <div className="hairline mb-10 justify-center"><span>A · M</span></div>

      <div className="border border-hairline bg-ivory p-8 sm:p-12 space-y-8">
        <div className="flex items-start gap-5" data-testid="contact-email">
          <div className="mt-1 h-10 w-10 rounded-full border border-gold flex items-center justify-center text-gold shrink-0">
            <Mail size={16} strokeWidth={1.3} />
          </div>
          <div className="min-w-0">
            <div className="text-[10px] tracking-[0.3em] uppercase text-gold">Email</div>
            <a
              href="mailto:hello@etalevents.com"
              data-testid="contact-email-link"
              className="mt-1 block font-serif text-2xl sm:text-3xl text-ink break-all hover:text-gold-hover transition-colors"
            >
              hello@etalevents.com
            </a>
          </div>
        </div>

        <div className="flex items-start gap-5" data-testid="contact-phone">
          <div className="mt-1 h-10 w-10 rounded-full border border-gold flex items-center justify-center text-gold shrink-0">
            <Phone size={16} strokeWidth={1.3} />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-gold">Phone / WhatsApp · Detola</div>
            <a
              href="tel:+2348105660037"
              data-testid="contact-phone-link"
              className="mt-1 block font-serif text-2xl sm:text-3xl text-ink hover:text-gold-hover transition-colors"
            >
              +234 810 566 0037
            </a>
            <a
              href="https://wa.me/2348105660037"
              target="_blank" rel="noopener noreferrer"
              data-testid="contact-whatsapp-link"
              className="mt-2 inline-block text-[10px] tracking-[0.3em] uppercase text-gold hover:text-gold-hover transition-colors"
            >
              Message on WhatsApp →
            </a>
          </div>
        </div>

        <div className="pt-4 border-t border-hairline text-sm text-ink-faint leading-relaxed">
          Etal Events is coordinating all Traditional Wedding logistics. For anything else, please reach out to Anjola or Michael directly.
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
